// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__9jhyu","content":"styles_content__3H-YE","checkbox":"styles_checkbox__1r6pJ","checkboxLabel":"styles_checkboxLabel__ablV2"};